import { colors } from "../../Styles";

export function Phone({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g transform="matrix(1,0,0,1,0.443619,-2.92392)">
        <path d="M100.3,103.73C100.3,103.73 123.09,88.4 126.82,85.5C130.55,82.6 133.45,76.8 130.55,66.44C127.65,56.08 122.2,39.92 116.02,29.97C109.83,20.02 53.48,35.77 52.65,39.09C51.82,42.41 38.56,122.38 89.12,187.03C139.68,251.67 188.99,264.11 193.96,262.45C198.93,260.79 232.91,221.84 232.08,213.55C231.25,205.26 202.66,179.16 192.71,174.18C182.76,169.21 159.14,193.66 159.14,193.66C159.14,193.66 101.13,152.64 100.3,103.74L100.3,103.73Z"/>
      </g>
    </svg>
  );
}